module.exports = "/* dummy val to identify this style sheet in style section  */\n.se-element {\n  display: block;\n}\nimg {\n  width: 100%;\n  height: 100%;\n}\n.image-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.flip-container {\n  position: relative;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-image/se-image.component.css
// module id = ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-image/se-image.component.css
// module chunks = main